import { Location } from "history";
import { matchPath } from "react-router-dom";

import { linkToRegionModal } from "common/links";

import {
  linkToAssignmentSummaryRoute,
  linkToParentWhatIsPremium,
  linkToSettings
} from "features/parents/links";
import { linkToChildAssignmentsPage } from "features/parents/routes/parent/routes/child/routes/assignments/links";
import { FeedbackParamKey } from "features/parents/routes/parent/routes/feedback/consts";
import { linkToMorePage } from "features/parents/routes/parent/routes/mobile/more/links";

export function locationIncludesMoreRoute(location: Location) {
  return (
    location.pathname.includes(linkToMorePage()) ||
    location.pathname.includes(linkToSettings()) ||
    location.pathname.includes(FeedbackParamKey) ||
    location.pathname.includes(linkToRegionModal()) ||
    location.pathname.includes(linkToParentWhatIsPremium())
  );
}

export function locationIncludesAssignmentsRoute({
  location,
  selectedChildId
}: {
  location: Location;
  selectedChildId: string | undefined;
}) {
  return (
    location.pathname.includes(linkToChildAssignmentsPage(selectedChildId)) ||
    !!matchPath(location.pathname, { path: linkToAssignmentSummaryRoute() })
  );
}
